import {useContext} from 'react';
import {AppContext} from '../../contexts/app/context';
import {AppContextType} from '../../contexts/app/types';
import {ThemeMode} from '../../enums/theme-mode';
import {ReactComponent as LightLogo} from '../../logos/logo-light.svg';
import {ReactComponent as DarkLogo} from '../../logos/logo-dark.svg';
import {ReactComponent as PrimaryLogo} from '../../logos/logo-primary.svg';

/**
 * Product logo component.
 */
export const ProductLogo = (props: {height: number; usePrimary?: boolean}) => {
  // Get context
  const appContext: AppContextType = useContext(AppContext);

  // Hold logo component
  let Logo: any;

  // Evaluate current theme mode
  if (props.usePrimary && appContext.state.currentThemeMode !== ThemeMode.Dark) {
    // Use Primary
    Logo = PrimaryLogo;
  } else if (appContext.state.currentThemeMode === ThemeMode.Dark) {
    // Go Dark
    Logo = DarkLogo;
  } else {
    // Go Light
    Logo = LightLogo;
  }

  // Default result
  return (
    <Logo
      height={props.height}
      width={props.height * appContext.state.currentThemeSettings.logoWidthHeightRatio}
    />
  );
};
